import { Action, Selector, State, StateContext } from '@ngxs/store';
import { switchMap, tap, pluck } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TerminalManagement, AppModuleManagement } from '../models';
import { TerminalManagementService } from '../services/terminal-management.service';
import { AppTerminalSettingService } from '../services/app-terminal-setting.service';
import { GetListTerminal, GetTerminal, EnableTerminal, DisableTerminal, DeleteTerminal, UpdateTerminal, BindAppModules, BindUsers, UnBindAppModules, UnBindUsers, GetAppTerminalSettings } from '../actions/terminal-management.actions';


@State<TerminalManagement.State>({
    name: 'TerminalManagement',
    defaults: {

    } as TerminalManagement.State,
})
@Injectable()
export class TerminalManagementState {

    @Selector()
    static terminals({ terminals }: TerminalManagement.State): TerminalManagement.TerminalItem[] {
        return terminals.items;
    }

    @Selector()
    static terminalTotalCount({ terminals }: TerminalManagement.State): number {
        return terminals.totalCount;
    }

    @Selector()
    static appTerminalSettings({ currentTerminalSettings }: TerminalManagement.State): AppModuleManagement.AppTerminalSettingItem {
        return currentTerminalSettings;
    }

    constructor(
        private terminalManagemantService: TerminalManagementService,
        private appTerminalSettingService: AppTerminalSettingService) {

    }


    @Action(GetListTerminal)
    getList({ patchState }: StateContext<TerminalManagement.State>, { payload }: GetListTerminal) {
        return this.terminalManagemantService.getList(payload).pipe(
            tap(
                terminals =>
                    patchState({
                        terminals
                    })
            ),
        );
    }

    @Action(GetTerminal)
    select({ patchState }: StateContext<TerminalManagement.State>, { id }: GetTerminal) {
        return this.terminalManagemantService.getTerminal(id).pipe(
            tap(
                terminal => patchState({
                    selectedTerminal: terminal
                })
            )
        );
    }

    @Action(EnableTerminal)
    enable(_, { machineCode, tenantId }: EnableTerminal) {
        return this.terminalManagemantService.enable(machineCode, tenantId);
    }

    @Action(DisableTerminal)
    disable(_, { machineCode, tenantId }: DisableTerminal) {
        return this.terminalManagemantService.disable(machineCode, tenantId);
    }

    @Action(DeleteTerminal)
    deleteTerminal(_, { id }: DeleteTerminal) {
        return this.terminalManagemantService.deleteTerminal(id);
    }

    @Action(UpdateTerminal)
    update(_, { payload }: UpdateTerminal) {
        return this.terminalManagemantService.update(payload);
    }

    @Action(BindAppModules)
    bindAppModules(_, { payload }: BindAppModules) {
        return this.appTerminalSettingService.bindModules(payload);
    }

    @Action(BindUsers)
    bindUsers(_, { payload }: BindUsers) {
        return this.appTerminalSettingService.bindUsers(payload);
    }

    @Action(UnBindAppModules)
    unbindAppModules(_, { payload }: UnBindAppModules) {
        return this.appTerminalSettingService.unBindModules(payload);
    }

    @Action(UnBindUsers)
    unBindUsers(_, { payload }: UnBindUsers) {
        return this.appTerminalSettingService.unBindUsers(payload);
    }

    @Action(GetAppTerminalSettings)
    getAppTerminalSettings({ patchState }: StateContext<TerminalManagement.State>, { terminalId }: GetAppTerminalSettings) {
        return this.appTerminalSettingService.getTerminalSetting(terminalId)
            .pipe(
                tap(
                    settings => patchState({
                        currentTerminalSettings: settings
                    })
                )
            )
    }

}
